
<div [class]="'legend-opener ' + (legendOpened ? 'legend-collapse' : 'legend-expand')">
    <div class="legend-frame-2111">
        <div class="legend-frame-2110" (click)="showHideLegend(true)">
            <span class="title">Legend</span>
            <img 
                src="assets/images/MapLegend/add.svg" alt="Open">
        </div>
    </div>
</div>

<div [class]="'legend-container ' + (legendOpened ? 'legend-expand' : 'legend-collapse')" (click)="showHideLegend(false)"> 
    <div class="legend-detail">
        <div class="legend-frame-2110">
            <span class="title">Legend</span>
            <img src="assets/images/MapLegend/remove.svg" alt="Close">
        </div>

        <div class="frame-2073">
            <div class="frame-2074-2075">
                <div class="wq-full-indicator">
                    <img class="icon" src="assets/images/WaterqualityForecastIndicator/Green.svg" width="24px" height="24px">
                    <span class="text">Pollution unlikely</span>
                </div>
                <div class="wq-full-indicator">
                    <img class="icon" src="assets/images/WaterqualityForecastIndicator/Yellow.svg" width="24px" height="24px">
                    <span class="text">Pollution possible</span>
                </div>
            </div>
            <div class="frame-2074-2075">
                <div class="wq-full-indicator">
                    <img class="icon" src="assets/images/WaterqualityForecastIndicator/Red.svg" width="24px" height="24px">
                    <span class="text">Pollution likely</span>
                </div>
                <div class="wq-full-indicator">
                    <img class="icon" src="assets/images/WaterqualityForecastIndicator/Unavailable.svg" width="24px" height="24px">
                    <span class="text">Forecast not available</span>
                </div>
            </div>
        </div>
        <div class="frame-2081">
            <span class="title">Water quality forecast:</span>
            <span class="desc">
                Daily predicted pollution based on recent rainfall and other information available.
            </span>
        </div>
    </div>   
</div>


    